module.exports = __webpack_public_path__ + "img/tip1.e3a3d4b5.png";